import { builtinNativeClasses, nativeClasses } from './builtinNativeClasses';
export function getNativeInitializer(classInfo) {
    var methodInfo = classInfo.instanceInfo.methodInfo;
    var className = classInfo.instanceInfo.getClassName();
    var asClass = builtinNativeClasses[className] || nativeClasses[className];
    if (methodInfo.isNative() || (asClass === null || asClass === void 0 ? void 0 : asClass.forceNativeConstructor)) {
        // Use TS constructor as the initializer function.
        return asClass;
    }
    //// TODO: Assert eagerly.
    //return function () {
    //  release || assert (!methodInfo.isNative(), "Must supply a constructor for " + classInfo +
    // "."); }
    return null;
}
